import React from 'react';
import { Box, Typography } from '@mui/material';

/** KPI 卡片内标题与数值 Typography 共用排版（与设计稿一致） */
const titleTypographySx = { color: 'var(--text-dark)', textAlign: 'center' as const };
const valueTypographySx = {
    color: 'var(--text-primary-300)',
    fontWeight: 'bold' as const,
    textAlign: 'center' as const,
};

export interface GroupTotalRevenueKpiCardProps {
    /** 卡片标题文案 */
    title: React.ReactNode;
    /** 主指标展示内容 */
    value: React.ReactNode;
    /** 环比等第三行，不传则不渲染（如仅两行的 KPI） */
    subtitle?: React.ReactNode;
}

/**
 * 集团营业总额 Tab 顶部 KPI 白卡片：统一圆角、阴影与内部三块内容的纵向间距（12px）。
 */
export function GroupTotalRevenueKpiCard({ title, value, subtitle }: GroupTotalRevenueKpiCardProps) {
    return (
        <Box
            sx={{
                flex: 1,
                bgcolor: 'var(--fill-neutral-100)',
                borderRadius: '16px',
                p: 4,
                minHeight: '160px',
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                boxShadow: '0px 0px 4px var(--shadow-25)',
            }}
        >
            <Typography variant="h6" sx={titleTypographySx}>
                {title}
            </Typography>
            <Typography variant="h4" sx={valueTypographySx}>
                {value}
            </Typography>
            {subtitle}
        </Box>
    );
}
